import {SampleDetails} from 'constants/SampleConstants';

/**
 * Function to extract the ID of a sample from a SampleDetails object.
 */

export default function getSampleId(sample: SampleDetails): string | null {
  return (
    sample.bioentityInfo?.id ??
    sample.batchInfo?.id ??
    sample.boxInfo?.id ??
    sample.plateInfo?.id ??
    sample.containerInfo?.id ??
    sample.textInfo?.id ??
    sample.numberInfo?.id ??
    sample.booleanInfo?.id ??
    null
  );
}
